<template>
  <div class="bg-2 pos-r">
    <div class="pos-a right-20 mg-t--180 pointer" @click="clickBack()"><img class="wd-160"
        :src="require('@/assets/foot/lobby.png')" /></div>
    <div class="pd-30 pd-b-20">
      <Row :gutter="20">
        <Col :xs="24" :sm="12">
        <!-- <div :class="mob ? '' : 'pd-20'"><img :class="mob ? 'wd-50p' : ''" :src="require('@/assets/foot.png')" /></div> -->
        <div class="font-18 cr-white dp-f">
          <div @click="clickref('/TermsofUse')" class="pointer">Terms Of Use</div>
          <div> | © Copyright 2022. iGet Holdings Pte Ltd</div>
        </div>
        </Col>
        <Col :xs="24" :sm="12">
        <div class="ht-100p dp-f fx-ali-e jus-e" :class="mob ? 'pd-t-15' : ''">
          <div class="dp-flex jus-c pointer" :class="mob ? 'wd-60' : 'wd-80 '" v-for="(item, i) in list" :key="i"
            @click="clickLink(item.link)">
            <img :src="require('@/assets/foot/icon-' + i + '.png')" />
          </div>
        </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      list: [
        {
          name: 'Facebook',
          link: "https://www.facebook.com/igetentertainment/",
        },
        {
          name: 'Youtube',
          link: 'https://www.youtube.com/channel/UCPmRsHe491e93Jlj9J-Fp4A',
        },
        {
          name: 'Twitter',
          link: 'https://twitter.com/igetentertain',
        },
        {
          name: 'Instagram',
          link: 'https://www.instagram.com/igetentertainment/',
        },
      ],
    };
  },
  computed: {
    mob() {
      return this.$store.state.mob;
    }
  },
  created() { },
  mounted() {
  },
  watch: {},
  methods: {
    clickBack() {
      this.pushr("/");
    },
    clickref(ref) {
      this.pushr(ref);
    },
    clickLink(ref) {
      window.open(ref);
    },
  },
  beforeDestroy() { },
};
</script>
